export const AssetPlaceholder = {
  typeName: 'Enter asset type name, e.g. Guard Dog',
  typeId: 'Enter asset type id. e.g. CAN-0001',
  assetId: 'Enter unique asset id. E.g. AST-0001',
  assetName: 'Enter asset name. e.g. Bluey',
  vehicleId: 'Enter registration e.g. SDN7484U',
};

export const BASE_ASSET_CATEGORY = {
  // GENERAL
  PHONE: {
    id: 'PHONE',
    value: 'Phone',
  },
  VEHICLE: {
    id: 'VEHICLE',
    value: 'Vehicle',
  },
  CONSUMABLE: {
    id: 'CONSUMABLE',
    value: 'Consumable',
  },
  DISPOSABLE: {
    id: 'DISPOSABLE',
    value: 'Disposable',
  },
  OTHER: {
    id: 'OTHER',
    value: 'Other',
  },
  SENSOR: {
    id: 'SENSOR',
    value: 'Sensor',
  },
  ROBOT: {
    id: 'ROBOT',
    value: 'Automated System',
  },
  // SECURITY
  CANINE: {
    id: 'CANINE',
    value: 'Canine',
  },
  RADIO: {
    id: 'RADIO',
    value: 'Radio',
  },
  FIREARM: {
    id: 'FIREARM',
    value: 'Firearm',
  },

  // CLEANING
  TOOLS_EQUIPMENT: {
    id: 'TOOLS_EQUIPMENT',
    value: 'Tools & Equipment',
  },
  PPE: {
    id: 'PPE',
    value: 'PPE',
  },

  // MAINTENANCE
  CRITICAL_ASSETS: {
    id: 'CRITICAL_ASSETS',
    value: 'Critical Assets',
  },

  // TRANSPORT
  VEHICLE_OFF_ROAD: {
    id: 'VEHICLE_OFF_ROAD',
    value: 'Vehicle - Off Road',
  },
  VEHICLE_VAN: {
    id: 'VEHICLE_VAN',
    value: 'Vehicle - Van',
  },
  VEHICLE_BUS: {
    id: 'VEHICLE_BUS',
    value: 'Vehicle - Bus',
  },
};

export const assetCategoryOptions = [
  { id: BASE_ASSET_CATEGORY.CANINE.id, name: BASE_ASSET_CATEGORY.CANINE.value },
  {
    id: BASE_ASSET_CATEGORY.FIREARM.id,
    name: BASE_ASSET_CATEGORY.FIREARM.value,
  },
  { id: BASE_ASSET_CATEGORY.PHONE.id, name: BASE_ASSET_CATEGORY.PHONE.value },
  {
    id: BASE_ASSET_CATEGORY.VEHICLE.id,
    name: BASE_ASSET_CATEGORY.VEHICLE.value,
  },
  // {
  //   id: BASE_ASSET_CATEGORY.VEHICLE_OFF_ROAD.id,
  //   name: BASE_ASSET_CATEGORY.VEHICLE_OFF_ROAD.value,
  // },
  // {
  //   id: BASE_ASSET_CATEGORY.VEHICLE_VAN.id,
  //   name: BASE_ASSET_CATEGORY.VEHICLE_VAN.value,
  // },
  // {
  //   id: BASE_ASSET_CATEGORY.VEHICLE_BUS.id,
  //   name: BASE_ASSET_CATEGORY.VEHICLE_BUS.value,
  // },
  { id: BASE_ASSET_CATEGORY.ROBOT.id, name: BASE_ASSET_CATEGORY.ROBOT.value },
  { id: BASE_ASSET_CATEGORY.SENSOR.id, name: BASE_ASSET_CATEGORY.SENSOR.value },
  {
    id: BASE_ASSET_CATEGORY.TOOLS_EQUIPMENT.id,
    name: BASE_ASSET_CATEGORY.TOOLS_EQUIPMENT.value,
  },
  {
    id: BASE_ASSET_CATEGORY.CRITICAL_ASSETS.id,
    name: BASE_ASSET_CATEGORY.CRITICAL_ASSETS.value,
  },
  {
    id: BASE_ASSET_CATEGORY.PPE.id,
    name: BASE_ASSET_CATEGORY.PPE.value,
  },
  { id: BASE_ASSET_CATEGORY.OTHER.id, name: BASE_ASSET_CATEGORY.OTHER.value },
];

export const ASSET_MANDATORY_IMAGE = [
  BASE_ASSET_CATEGORY.VEHICLE.id,
  BASE_ASSET_CATEGORY.VEHICLE_OFF_ROAD.id,
  BASE_ASSET_CATEGORY.VEHICLE_VAN.id,
  BASE_ASSET_CATEGORY.VEHICLE_BUS.id,
];

export const assetStatus = {
  AVAILABLE: 'AVAILABLE',
  DEPLOYING: 'DEPLOYING',
  IN_USE: 'IN_USE',
  RETURNING: 'RETURNING',
  UNAVAILABLE: 'UNAVAILABLE',
  UNREGISTERED: 'UNREGISTERED',
};
